import { NullableString } from "@/code/Types";
import { BaseClientDocument } from "./BaseDocuments";

export class AdvisorClientLatestOpportunityStatusData extends BaseClientDocument {
 clientFirstName: NullableString = null;
 clientLastName: NullableString = null;
 clientFullName:NullableString = null;
}
